import { render, staticRenderFns } from "./ActionRequired.vue?vue&type=template&id=66bac2c2"
import script from "./ActionRequired.vue?vue&type=script&lang=js"
export * from "./ActionRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports